import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'ntt-spinner',

  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class Spinner {
  size = input<'sm' | 'md' | 'lg' | 'xl'>('md');
  color = input<'primary' | 'accent' | 'warning' | 'danger'>('primary');
  classes = computed(() =>
    [
      'ntt-spinner',
      `ntt-spinner--${this.size()}`,
      `ntt-spinner--${this.color()}`,
    ].join(' '),
  );
}
